import { colorsDark } from '../../themes/dark-colors';
import { tagVariants } from './Tag.variants';

export const tagDarkTheme = {
  variants: tagVariants,
  fieldFilter: {
    borderColor: { active: colorsDark.blue[600], negate: colorsDark.red[600], invalid: colorsDark.gray[600] },
    backgroundColor: {
      default: colorsDark.gray[0],
      hover: {
        active: colorsDark.blue[200],
        negate: colorsDark.red[100],
      },
    },
    color: {
      default: colorsDark.royalBlue[1000],
      invalid: colorsDark.gray[600],
    },
  },
  severity: {
    color: colorsDark.gray[0],
  },
};
